import { useContext } from "react";
import { config } from "../config";
import { AuthContext } from "../useAuth";

export const getAvatarPath = (user) => {
  return user?.Avatar ? `${config.imageUrl}/${user.Avatar}` : undefined;
};

export const displayUserName = (user) => {
  const { FirstName, LastName, Email } = user;
  let name =
    FirstName && LastName
      ? `${FirstName} ${LastName}`
      : FirstName
      ? FirstName
      : Email;
  return name;
};

export const isCaregiver = (user) => {
  return user?.Roles?.includes("caregiver");
};

export const isParent = (user) => {
  return user?.Roles?.includes("parent");
};

export const isOrgAdmin = (user) => {
  return user?.Roles?.includes("organization_admin");
};
